// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__b9mEc","selected":"Chip_selected__VD5Hy"};